/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Upgrade_Modal_TitleInputs */

const en_upgrade_modal_title = /** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upgrade to ${i?.tier}`)
};

const es_upgrade_modal_title = /** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mejorar a ${i?.tier}`)
};

const fr_upgrade_modal_title = /** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passer à ${i?.tier}`)
};

const de_upgrade_modal_title = /** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upgrade auf ${i?.tier}`)
};

const id_upgrade_modal_title = /** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tingkatkan ke ${i?.tier}`)
};

/** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */
const ja_upgrade_modal_title = en_upgrade_modal_title;

/** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */
const zh_upgrade_modal_title = en_upgrade_modal_title;

/** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */
const ar_upgrade_modal_title = en_upgrade_modal_title;

/** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */
const it_upgrade_modal_title = en_upgrade_modal_title;

/** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */
const ru_upgrade_modal_title = en_upgrade_modal_title;

/** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */
const pt_upgrade_modal_title = en_upgrade_modal_title;

/** @type {(inputs: Upgrade_Modal_TitleInputs) => LocalizedString} */
const ko_upgrade_modal_title = en_upgrade_modal_title;

/**
* | output |
* | --- |
* | "Upgrade to {tier}" |
*
* @param {Upgrade_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_modal_title = /** @type {((inputs: Upgrade_Modal_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Modal_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_modal_title(inputs)
	if (locale === "es") return es_upgrade_modal_title(inputs)
	if (locale === "fr") return fr_upgrade_modal_title(inputs)
	if (locale === "de") return de_upgrade_modal_title(inputs)
	if (locale === "ja") return ja_upgrade_modal_title(inputs)
	if (locale === "zh") return zh_upgrade_modal_title(inputs)
	if (locale === "ar") return ar_upgrade_modal_title(inputs)
	if (locale === "id") return id_upgrade_modal_title(inputs)
	if (locale === "it") return it_upgrade_modal_title(inputs)
	if (locale === "ru") return ru_upgrade_modal_title(inputs)
	if (locale === "pt") return pt_upgrade_modal_title(inputs)
	return ko_upgrade_modal_title(inputs)
});